module.exports = __webpack_public_path__ + "hat-twilight.34cc20c85e61f5c5274c.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/hat-twilight.svg
// module id = ../../../../../src/assets/img/hat-twilight.svg
// module chunks = main